import { lazy, type ComponentType, type ReactNode } from 'react'

type DynamicOpts = { ssr?: boolean; loading?: () => ReactNode }

/**
 * Minimal subset of `next/dynamic` for Vite: returns `React.lazy` of the loader.
 * Call sites should wrap usage in `<Suspense>` where a loading UI is required.
 */
export default function dynamic<P extends object>(
  loader: () => Promise<{ default: ComponentType<P> }>,
  _opts?: DynamicOpts,
): ComponentType<P> {
  return lazy(loader) as ComponentType<P>
}
